import { VariableComplexityPolicyDto } from '@/features/variable-complexity-policy/api/types';
import { queryKeys } from '@/hooks/constants';
import { useMutationWithLogging } from '@/hooks/useMutationWithLogging';
import { useQueryWithLogging } from '@/hooks/useQueryWithLogging';
import AppService from '@/lib/App';
import { VariableComplexityPolicyPayload } from '@/lib/PlannerService';

export function useGetVariableComplexityPolicy(options?: {
  [key: string]: any;
}) {
  return useQueryWithLogging({
    queryKey: queryKeys.planner.variableComplexityPolicy(),
    queryFn: () => AppService.planner.getVariableComplexityPolicies(),
    ...options,
  });
}

export function useUpdateVariableComplexityPolicy(options?: {
  [key: string]: any;
}) {
  return useMutationWithLogging({
    mutationKey: queryKeys.planner.updateVariableComplexityPolicy(),
    mutationFn: async (policy: VariableComplexityPolicyDto) =>
      await AppService.planner.saveVariableComplexityPolicies(policy),
    ...options,
  });
}

export function useGetVariableComplexityServices(options?: {
  [key: string]: any;
}) {
  return useQueryWithLogging({
    queryKey: queryKeys.planner.variableComplexityServices(),
    queryFn: () => AppService.planner.getVariableComplexityServices(),
    enabled: false,
    ...options,
  });
}

export function useRecomputeVariableComplexityThreshold(options?: {
  [key: string]: any;
}) {
  return useMutationWithLogging({
    mutationKey: queryKeys.planner.recomputeVariableComplexityThreshold(),
    mutationFn: async (
      payload: VariableComplexityPolicyPayload & { skip_services: string[] },
    ) => await AppService.planner.recomputeVariableComplexityThreshold(payload),
    ...options,
  });
}

export function useBackfillVariableComplexity(options?: {
  [key: string]: any;
}) {
  return useMutationWithLogging({
    mutationKey: queryKeys.planner.backfillVariableComplexity(),
    mutationFn: async (payload?: { skip_services: string[] }) =>
      await AppService.planner.backfillVariableComplexity(payload),
    ...options,
  });
}
